import PropTypes from 'prop-types';
import React from 'react';
import { Dimensions, Image, StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import FormatService from '../../lib/format';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import Modal from '../common/ConfirmationModal/Modal';

function getStyles() {
  return StyleSheet.create({
    price: {
      position: 'absolute',
      top: 0,
      right: 10,
      fontSize: 24,
      fontWeight: '600',
      color: theme.primaryColor,
      backgroundColor: 'transparent',
    },
    voucherImage: {
      width: null,
      height: 150,
    },
    voucherView: {
      // Because of parent margin 20 and padding 10 (2*20 + 2*10)
      width: Dimensions.get('window').width - 60,
    },
    voucherBand: {
      backgroundColor: 'rgba(255,255,255, 0.4)',
      position: 'absolute',
      bottom: 15,
      left: 0,
      right: 0,
      padding: 5,
      alignItems: 'center',
    },
    voucherCode: {
      color: 'white',
    },
  });
}

const VoucherModal = props => {
  const styles = getStyles();
  return (
    <Modal
      confirm={() => props.redeemVoucher(props.customerOuid, props.code)}
      cancel={props.leaveAddMoneyScene}
      opened={!!props.code && !!props.voucherPrice}
      confirmContent={I18n.t('voucherModalText')}
      confirmText="redeem"
      loading={props.loading}
    >
      <View style={styles.voucherView}>
        <Image resizeMode="cover" style={styles.voucherImage} source={theme.voucherImage} />
        <Text style={styles.price}>{FormatService.formatCentsToCurrency(props.voucherPrice, true)}</Text>
        <View style={styles.voucherBand}>
          <Text style={styles.voucherCode}>{props.code}</Text>
        </View>
      </View>
    </Modal>
  );
};

VoucherModal.propTypes = {
  code: PropTypes.string,
  customerOuid: PropTypes.string.isRequired,
  leaveAddMoneyScene: PropTypes.func,
  loading: PropTypes.bool,
  redeemVoucher: PropTypes.func.isRequired,
  voucherPrice: PropTypes.number,
};

export default VoucherModal;
